import React, { useState } from "react";

function ImageWithLoader({ src, alt, width, height }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div style={{ width, height, position: "relative" }}>
      {!loaded && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f0f0f0",
          }}
        >
          {/* Simple loader (spinner ya text) */}
          <div className="loader"></div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        style={{ display: loaded ? "block" : "none" }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}

export default ImageWithLoader;
